// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { FileTemplate } from './FileTemplate';
/**
 * 模版参数 实体类
 * 模版参数
 */
export class TemplateParam extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 参数说明 : 参数说明 */
  private _description: string;

  /** 设置：参数说明 */
  public get description() {
    return this._description;
  }

  /** 获取：参数说明 */
  public set description(value: string) {
    this._description = value;
  }

  /** 模版 的ID */
  private _template_ID: string;

  /** 获取：模版 的ID */
  public get template_ID() {
    return this._template_ID;
  }

  /** 设置：模版 的ID */
  public set template_ID(value: string) {
    this._template_ID = value;
  }

  /** 模版  */
  private _template: FileTemplate;

  /** 获取：模版  */
  public get template() {
    return this._template;
  }

  /** 设置：模版  */
  public set template(value: FileTemplate) {
    this._template = value;
    if (value !== null) {
      this.template_ID = value.id;
    } else {
      this.template_ID = '';
    }
  }

  constructor() {
    super();
    this._name = '';
    this._description = '';
    this._template_ID = '';
    this._template = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: TemplateParam, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.description = element.description;
      this.template_ID = element.template_ID;
      if (hasReference && element.template !== null) {
        this.template = element.template;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.description = json.Description;
    this.template_ID = json.Template_ID;
    // if (json.Template !== null) {
    //   this.template = FileTemplate.Create(json.Template);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Description = this.description;
    json.Template_ID = this.template_ID;
  }

  static Create(json: any): TemplateParam {
    const templateParam = new TemplateParam();
    templateParam.Deserialize(json);
    templateParam.json = json;
    return templateParam;
  }
}
